import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '../../Modal/Modal';
import SecondaryUserTerms from './SecondaryUserTerms';
import PrimaryUserTerms from './PrimaryUserTerms';
import { getCurrentAccountUid } from '../../../store/selectors/accountSelectors';

/* Use for static testing
const termsArray = [
  {
    label: 'User Terms',
    value: 'userTerms',
  },
  {
    label: 'IRA Terms',
    value: 'iraTerms',
  },
  {
    label: 'ACH Terms',
    value: 'achTerms',
  },
  {
    label: 'Terminally Ill Terms',
    value: 'terminallyIllTerms',
  },
  {
    label: 'Absurd Terms',
    value: 'absurdTerms',
  },
]; */

const TermsModal = ({
  isPrimary,
  primaryUserFirstName,
  primaryUserLastName,
  isImpersonating,
  isModalOpen,
  closeModal,
  termsArray,
  onSuccess,
  userWithMultipleAccounts,
}) => {
  const { t } = useTranslation();
  const accountUid = useSelector(getCurrentAccountUid);
  return (
    <Modal
      title={
        isPrimary
          ? t('updatedTerms.primary.titleEmoji')
          : t('updatedTerms.secondary.titleEmoji')
      }
      size="lg"
      isOpen={isModalOpen}
      close={closeModal}
      isCenterModal
    >
      {isPrimary && !isImpersonating ? (
        <PrimaryUserTerms
          termsArray={termsArray}
          accountUid={accountUid}
          onSuccess={onSuccess}
          userWithMultipleAccounts={userWithMultipleAccounts}
        />
      ) : (
        <SecondaryUserTerms
          primaryUserFirstName={primaryUserFirstName}
          primaryUserLastName={primaryUserLastName}
        />
      )}
    </Modal>
  );
};

TermsModal.propTypes = {
  isPrimary: PropTypes.bool,
  primaryUserFirstName: PropTypes.string,
  primaryUserLastName: PropTypes.string,
  isImpersonating: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  termsArray: PropTypes.arrayOf({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  onSuccess: PropTypes.func,
  userWithMultipleAccounts: PropTypes.bool,
};

export default TermsModal;
